import __request__ from "routing/request";
export function updateConfig(config2) {
  return __request__("PUT", "/system/messageprocessors/config", config2, {}, {
    "Accept": ["application/json"]
  });
}
export function config() {
  return __request__("GET", "/system/messageprocessors/config", null, {}, {
    "Accept": ["application/json"]
  });
}
